import { Loader2 } from 'lucide-react';

interface LoadingOpacityProps {
  isOpen: boolean;
}

function LoadingOpacity({ isOpen }: LoadingOpacityProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-lg bg-card p-4 shadow-lg">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <p className="text-xs font-medium text-muted-foreground">
          جاري التحميل...
        </p>
      </div>
    </div>
  );
}

export default LoadingOpacity;
